enum ActionTypes {
	request = 'MedicinalBrandsAnalytics.VirtualBrand.request',
	addAnalyticsOfVirtualBrand = 'MedicinalBrandsAnalytics.addAnalyticsOfVirtualBrand.add',
	requestAnalyticsOfVirtualBrand = 'MedicinalBrandsAnalytics.AnalyticsOfVirtualBrand.request',
	receive = 'MedicinalBrandsAnalytics.VirtualBrand.receive',
	add = 'MedicinalBrandsAnalytics.VirtualBrand.add',
	requestAddGroupActualPacks = 'MedicinalBrandsAnalytics.VirtualBrand.requestAddGroupActualPacks',
	receiveAddGroupActualPacks = 'MedicinalBrandsAnalytics.VirtualBrand.receiveAddGroupActualPacks',
	requestAnalyticsExport = 'MedicinalBrandsAnalytics.VirtualBrand.requestAnalyticsExport',
	receiveAnalyticsExport = 'MedicinalBrandsAnalytics.VirtualBrand.receiveAnalyticsExport',
}

export default ActionTypes;
